
const SIZES = ['medium', 'small', 'large']
export default {
  name: 'AppSection',

  props: {
    className: {
      type: String,
      required: false,
      default: ''
    },

    section: {
      type: Boolean,
      required: false,
      default: false
    },

    fluid: {
      type: Boolean,
      required: false,
      default: false
    },

    sectionSize: {
      type: String,
      required: false,
      default: 'medium',
      validator: value => SIZES.includes(value)
    }
  },

  computed: {
    sectionSizeClass() {
      return this.section ? `gb-section_size-${this.sectionSize}` : ''
    }
  }
}
